import { levelMeta } from "../lib/courseMeta";

/** Niveau d'un cours : 3 petites barres orange + libellé. N'affiche rien si le niveau n'est pas renseigné. */
export default function LevelIndicator({ level, className = "" }) {
  const meta = levelMeta(level);
  if (!meta) return null;
  return (
    <span className={`inline-flex items-center gap-1.5 text-[11px] text-zinc-400 ${className}`} data-testid="course-level">
      <span className="inline-flex items-end gap-0.5" aria-hidden="true">
        {[1, 2, 3].map((i) => (
          <span
            key={i}
            className={`w-1 rounded-sm ${i <= meta.n ? "bg-orange-400" : "bg-white/15"}`}
            style={{ height: `${4 + i * 3}px` }}
          />
        ))}
      </span>
      {meta.label}
    </span>
  );
}
